import { useCallback, useEffect, useRef } from 'react';
export const useStableCallback = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    return useCallback((...args) => {
        const result = callbackRef.current(...args);
        return result;
    }, []);
};
//# sourceMappingURL=useStableCallback.js.map